import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30f8e7c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=30f8e7c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8e7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/syx-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f8e7c2')) {
      api.createRecord('30f8e7c2', component.options)
    } else {
      api.reload('30f8e7c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30f8e7c2&scoped=true", function () {
      api.rerender('30f8e7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/reminder/index.vue"
export default component.exports